import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";

@Component({
    selector: 'app-ssdf-application-batch-chart',
    templateUrl: './ssdf-application-batch-chart.component.html',
    styleUrls: ['./ssdf-application-batch-chart.component.scss']
})
export class SsdfApplicationBatchChartComponent implements OnChanges {

    @Input() title: string;
    @Input() appNumber: number;
    @Input() color: string;
    @Input() textColor: string;
    @Input() numberColor: string;
    @Input() series: any[];
    @Input() labels: string[];
    parsedDifference: number;

    @Input() set difference(val: string) {
        this.parsedDifference = val ? Number(val) : 0;
    }


    chartConversions: ApexOptions;

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.series.currentValue && changes.labels.currentValue) {

            this.chartConversions = {
                chart: {
                    animations: {
                        enabled: true
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    height: '100%',
                    type: 'area',
                    sparkline: {
                        enabled: true
                    }
                },
                colors: [this.color],
                fill: {
                    colors: ['#38BDF8'],
                    opacity: 0.5
                },
                series: [
                    {
                        name: 'Application',
                        data: this.series
                    }
                ],
                stroke: {
                    curve: 'smooth'
                },
                tooltip: {
                    followCursor: true,
                    theme: 'dark'
                },
                xaxis: {
                    type: 'category',
                    categories: this.labels
                },
                yaxis: {
                    labels: {
                        formatter: (val): string => val.toString()
                    }
                }


            };

            this.cd.detectChanges();
        }

    }

}
